import { Stack } from "@mui/material";
import { PropsWithChildren, type JSX } from "react";

type HeaderCellActionBarProps = {
}

export default function HeaderCellActionBar({
    children
}: PropsWithChildren<HeaderCellActionBarProps>): JSX.Element {

    return (
        <Stack
            direction="row"
            sx={{
                alignItems: "center",
                justifyContent: "flex-start",
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                color: "action.active",
                padding: "0 var(--ag-cell-horizontal-padding)",
                fontSize: "1em"
            }}
        >
            {children}
        </Stack>
    );
}